import { mutations, Mutations } from './mutations';
import { queries, Queries } from './queries';

export type Requests = {
  mutations: Mutations;
  queries: Queries;
};

export const requests: Requests = {
  mutations,
  queries,
};
